import accountRoutes from "@/account/routes";
import areasRoutes from "@/areas/routes";
import canvassFlowRoutes from "@/canvassFlow/routes";
import canvassesRoutes from "@/canvasses/routes";
import contactsRoutes from "@/contacts/routes";
import homeRoutes from "@/home/routes";
import housesRoutes from "@/houses/routes";
import loginRoutes from "@/login/routes";
import onboardingFlowRoutes from "@/onboardingFlow/routes";
import settingsRoutes from "@/settings/routes";
import signupRoutes from "@/signup/routes";
import statsRoutes from "@/stats/routes";
import supportRoutes from "@/support/routes";
import usersRoutes from "@/users/routes";
import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(_to, _from, savedPosition) {
    return savedPosition ? savedPosition : { top: 0 };
  },
  routes: [
    ...homeRoutes,
    ...areasRoutes,
    ...canvassesRoutes,
    ...canvassFlowRoutes,
    ...contactsRoutes,
    ...housesRoutes,
    ...accountRoutes,
    ...signupRoutes,
    ...usersRoutes,
    ...loginRoutes,
    ...settingsRoutes,
    ...statsRoutes,
    ...supportRoutes,
    ...onboardingFlowRoutes,
  ],
});

export default router;
